import permissions from '@enums/user-permissions';

const ReportingPageOverview = () => import('@/pages/reporting/ReportingPageOverview.vue');
const ReportingPageStats = () => import('@/pages/reporting/ReportingPageStats.vue');
const ReportingPageRelativeShare = () => import('@/pages/reporting/ReportingPageRelativeShare.vue');
const ReportingPage = () => import('@/pages/reporting/ReportingPage.vue');
const ReportingPageComparisonWaterfall = () =>
  import('@/pages/reporting/ReportingPageComparisonWaterfall.vue');
const ReportingPageProduct = () => import('@/pages/reporting/ReportingPageProduct.vue');
const ReportingPagePriceLadder = () => import('@/pages/reporting/ReportingPagePriceLadder.vue');

const routes = [
  {
    path: '/reporting-main',
    name: 'ReportingPage',
    component: ReportingPage,
    linkText: 'navBar.reporting',
    omitFromNav: false,
    omitChildrenFromNavbar: true,
    meta: {
      featureKey: 'reportingControlsEnabled',
      requiresPermission: permissions.canViewReportingPage,
      titleExtension: 'reportingPage.title',
    },
    children: [
      {
        path: '',
        id: 'reporting',
        name: 'reporting',
        component: ReportingPageOverview,
        meta: {
          featureKey: 'reportingControlsEnabled',
          requiresPermission: permissions.canViewReportingPage,
          titleExtension: 'reportingPage.overview',
        },
      },
      {
        path: 'stats',
        name: 'stats',
        component: ReportingPageStats,
        meta: {
          featureKey: 'reportingControlsEnabled',
          requiresPermission: permissions.canViewStatsReport,
          titleExtension: 'reportingPage.sections.stats.title',
        },
      },
      {
        path: 'relative-share',
        name: 'relative-share',
        component: ReportingPageRelativeShare,
        meta: {
          featureKey: 'reportingControlsEnabled',
          requiresPermission: permissions.canViewRelativeShareReport,
          titleExtension: 'reportingPage.sections.relative-share.title',
        },
      },
      {
        path: 'price-ladder',
        name: 'price-ladder',
        component: ReportingPagePriceLadder,
        meta: {
          featureKey: 'reportingControlsEnabled',
          requiresPermission: permissions.canViewPriceLadderReport,
          titleExtension: 'reportingPage.sections.price-ladder.title',
        },
      },
      {
        path: 'comparison-waterfall',
        name: 'comparison-waterfall',
        component: ReportingPageComparisonWaterfall,
        meta: {
          featureKey: 'reportingControlsEnabled',
          requiresPermission: permissions.canViewComparisonWaterfallReport,
          titleExtension: 'reportingPage.sections.comparison-waterfall.title',
        },
      },
      {
        path: 'product',
        name: 'ReportingPageProduct',
        component: ReportingPageProduct,
        meta: {
          featureKey: 'reportingControlsEnabled',
          requiresPermission: permissions.canViewProductReport,
          titleExtension: 'reportingPage.sections.product.title',
        },
      },
    ],
  },
];

export default routes;
